export default {
  namespaced: true,//开启命名空间

  state:{
    benci:123

  },
  mutations:{
      updatebenci(state,val) {
        state.benci = val
      }
  },

  actions:{

  },

  getters:{

  }  

}